// extracted by mini-css-extract-plugin
export default {"withContent":"Button_withContent__nUuYW","svgIcon":"Button_svgIcon__AkAcq","small":"Button_small__BDoTB","iconOnly":"Button_iconOnly__yH1I5"};